import {createApi} from '@reduxjs/toolkit/query/react'

import {fetchBaseQuery} from '../../../utils/network/fetchBaseQuery'
import {makeSerializeQueryArgs} from '../../../utils/redux'
import {
  OfferCheckApiRequestParams,
  OfferCheckAPIResponse
} from '../../types/OfferCheck'

/**
 * API for offer check
 * @description This API is used to check if an offer is valid
 */
export const offerCheckApi = createApi({
  reducerPath: 'offerCheckApi',
  baseQuery: fetchBaseQuery({
    baseUrl: ''
  }),
  endpoints: builder => ({
    getOfferCheck: builder.query<
      OfferCheckAPIResponse,
      OfferCheckApiRequestParams
    >({
      keepUnusedDataFor: 0,
      query: ({url, experimentApiKey, headers = {}, options}) => ({
        url:
          url +
          (options?.subBrandCode
            ? `&subBrandCode=${options?.subBrandCode}`
            : ''),
        headers: {
          ...headers,
          'X-Api-Key': experimentApiKey
        }
      }),
      transformResponse: (
        response: OfferCheckAPIResponse,
        meta: {headers: Record<string, string>}
      ): OfferCheckAPIResponse => ({
        ...response,
        httpRequestId: meta.headers['x-request-id']
      }),
      serializeQueryArgs: makeSerializeQueryArgs<OfferCheckApiRequestParams>({
        ignoreKeys: ['options']
      })
    })
  })
})

export const {useGetOfferCheckQuery, useLazyGetOfferCheckQuery, usePrefetch} =
  offerCheckApi
